<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
        <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" @keyup.enter.native="clickSearch" :placeholder="$t('Axtar')"
              :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cells" :data="exportDataList" worksheet="My Worksheet" name="responses">
              <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i>
                {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">

        <el-checkbox @change="getData" v-model="item.myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
        &nbsp;&nbsp;
        <el-checkbox @change="getData" v-model="item.newClaim">{{$t('İş_açılıb')}}</el-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.participants.toString().includes(search) ||
            data.regionName.toLowerCase().includes(search.toLowerCase()) ||
            data.clientServiceUserName
              .toLowerCase()
              .includes(search.toLowerCase()) ||
            data.participants.toLowerCase().includes(search.toLowerCase()) ||
            data.dispAccidentNumber.toString().includes(search)
        )
          " style="width: 100%">
          <!-- <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label :type="
                scope.row.statusTypeId === 30
                  ? 'goldenrod'
                  : '' || scope.row.statusTypeId === 35
                    ? 'limeGreen'
                    : '' || scope.row.statusTypeId === 40
                      ? 'mediumBlue'
                      : '' || scope.row.statusTypeId === 45
                        ? 'greenYellow'
                        : '' || scope.row.statusTypeId === 50
                          ? 'coral'
                          : '' || scope.row.statusTypeId === 70
                            ? 'green'
                            : ''
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column> -->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary);; display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Hadisə_tarixi')" sortable prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" prop="policyTypeName" width="300">
          </el-table-column>
          <!-- <el-table-column :label="$t('Qeyd')"iyyat tarixi" sortable prop="callDateStr" width="150">
          </el-table-column> -->
          <el-table-column :label="$t('Rayon')" prop="regionName" width="150">
          </el-table-column>

          <el-table-column :label="$t('Cağrı_mərkəzi')" width="200" prop="createUserName">
          </el-table-column>
          <el-table-column :label="$t('Qəza_komissarı')" width="200" prop="accidentCommUserName">
          </el-table-column>
          <el-table-column :label="$t('İcraçı')" width="200" prop="clientServiceUserName">
          </el-table-column>

          <el-table-column :label="$t('F4')">
            <template slot-scope="scope">
              <status-label :type="scope.row.form4Status === 1 ? 'green' : 'red'" />
              {{ scope.row.form4Status === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="50">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button title="Hadisəyə keçid" @click="handleEdit(scope.row.id)" style="padding: 0 !important"
                size="large">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.id,'accident')" style="padding: 0 !important">
                <div class="square-icon"> <i title="Ümumi Statuslar" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
    <accident-status-view ref="status" />


  </div>
</template>

<script>
  import StatusLabel from "../components/StatusLabel.vue";
  import AccidentStatusView from "../components/AccidentStatusView.vue";
  import { DateToString, AddMonths, AddDays } from "../../services/helper";
  import {
    GetCallCenterAllAccidents,
  } from "src/services/accident";
  // import StatusLabel from "../components/StatusLabel.vue";
  export default {
    components: {
      StatusLabel,
      AccidentStatusView
    },
    data() {
      return {
        loading: false,
        data: [],
        exportDataList: [],
        totalRecords: 0,
        search: "",
        uid: this.$store.state.user.id,
        item: {
          startDate: null,
          endDate: null,
          searchType: 0,
          searchText: null,
          newClaim: false,
          myData: false,
          uid: this.$store.state.user.id,
          dataExport: 0,
          pageSize: 50,
          pageNumber: 1
        },
        displayData: [],
        filter: {
          page: 1,
          pagesize: 50,
        },
        cells: {
          'Hadisə #': 'dispAccidentNumber',
          'Tarix': 'accidentDateStr',
          'Rayon': 'regionName',
          'Çağrı mərkəzi': 'createUserName',
          'Qəza komissarı': 'accidentCommUserName',
          'İcraçı': 'clientServiceUserName',
          'Qiymətləndirici': 'techExpertUserName',
        },
      };

    },
    methods: {
      handleCommand(command) {
        let item = command.row;
        if (command.action === "edit") this.handleEdit(item.id);
        if (command.action === "user") this.handleUser(item);
      },
      handleEdit(id) {
        this.$router.push({
          path: "accident/" + id,
        });
      },
      handleStatusView(id, type) {
        this.$refs["status"].view(id, type);
      },
      handleUser(item) {
        this.$refs["user"].edit(item);
      },
      clickSearch() {
        this.filter.page = 1
        this.getData();
      },
      // getData() {
      //   this.loading = true;
      //   if (this.item.searchText == "") {
      //     this.item.searchText = null;
      //   }

      //   this.item.startDate = DateToString(this.item.startDate);
      //   this.item.endDate = DateToString(this.item.endDate);
      //   GetCallCenterAllAccidents(this.item).then((response) => {
      //     this.loading = false;
      //     if (response.data) {
      //       this.data = response.data;
      //       this.getDisplayData();
      //     }
      //   });
      // },
      loadTime() {
        this.item.startDate = AddMonths(new Date(), -2);
        this.item.endDate = AddDays(new Date(), +1);
      },
      // getDisplayData() {
      //   this.displayData = this.data.slice((this.filter.page - 1) * this.filter.pagesize, this.filter.page * this.filter.pagesize)
      // },
      // handleCurrentChange(val) {
      //   this.filter.page = val;
      //   this.getDisplayData();
      // },
      // handleSizeChange(val) {
      //   this.filter.pagesize = val
      //   this.getDisplayData();
      // },
      exportData() {
        this.item.startDate = DateToString(this.item.startDate);
        this.item.endDate = DateToString(this.item.endDate);
        this.item.dataExport = 1;
        GetCallCenterAllAccidents(this.item).then((response) => {
        
          if (response.data.data) {
            this.exportDataList = response.data.data;
          }
        }).finally(() => {
          this.item.dataExport = 0;
        });
      },
      getData() {
        this.loading = true;

        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          searchType: this.item.searchType,
          searchText: null,
          newClaim: this.item.newClaim,
          searchText: this.item.searchText || '',
          myData: this.item.myData,
          uid: this.uid,
          pageSize: this.filter.pagesize,
          pageNumber: this.filter.page,
          dataExport: this.item.dataExport
        };
        GetCallCenterAllAccidents(params).then((response) => {
          this.loading = false;
          if (response.data.isSuccess) {
            this.data = response.data.data;
            this.displayData = this.data;
            this.totalRecords = response.data.data?.[0].totalRecords;
          }
        });
      },
      // getDisplayData() {
      //   this.displayData = this.data.slice(
      //     (this.filter.page - 1) * this.filter.pagesize,
      //     this.filter.page * this.filter.pagesize
      //   );
      // },
      handleCurrentChange(val) {
        this.filter.page = val;
        this.getData();
      },
      handleSizeChange(val) {
        this.filter.pagesize = val;
        this.getData();
      },
    },
    mounted() {
      this.loadTime();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>